import { GrantAccessRequest, individualsService } from '@aslanpay/portal-common-lib';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const useGrantAccess = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, GrantAccessRequest>) => {
  return useMutation<unknown, Error, GrantAccessRequest>(
    ({ id }: GrantAccessRequest) => individualsService.grantAccess({ id }),
    {
      onSuccess,
      onError,
    }
  );
};

export default useGrantAccess;
